export type RegionConfig = "NA" | "EU";

/**
 * Retrieves the region configuration from the environment variables.
 * @returns {RegionConfig} The region configuration, either "NA" or "EU".
 * @throws {Error} If the region configuration is not set.
 */
export function loadRegionConfig(): RegionConfig {
	const { REGION } = process.env;

	if (!REGION) {
		throw new Error("REGION config is not set.");
	}

	return REGION as RegionConfig;
}
